import Lottie from "lottie-react";
import React from "react";

import Loading from "./loading.json";

const LoadingAnimation = () => <Lottie animationData={Loading} loop={true} />;

function Loader() {
	return (
		<div style={{ transform: "scale(0.8)", marginTop: "-150px", marginBottom: "-150px" }}>
			<LoadingAnimation />
		</div>
	);
}

export default Loader;
